<template>
    <button
        :id="id"
        :data-cy="dataCy"
        :type="type"
        :class="buttonClasses"
        :disabled="disabled"
        @click="handleClick"
    >
        <span>{{ label }}</span>
    </button>
</template>

<script setup>
    import { computed } from 'vue';
    import { useVersionMovil } from '@/composables/common/useVersionMovil';

    const props = defineProps({
        id: {
            type: String,
            default: undefined
        },
        dataCy: {
            type: String,
            default: undefined
        },
        label: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'button',
            validator: value => ['button', 'submit', 'reset'].includes(value)
        },
        disabled: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'large-button'
        }
    });

    const emit = defineEmits(['click']);

    const { esMovil } = useVersionMovil();

    const buttonClasses = computed(() => {
        const baseClasses = props.disabled ? 'button' : 'button effect-button';
        const sizeClass = !esMovil.value ? props.size : '';
        const customClasses = props.customClass;

        return [baseClasses, sizeClass, customClasses].filter(Boolean).join(' ');
    });

    const handleClick = event => {
        if (!props.disabled) {
            emit('click', event);
        }
    };
</script>
